import { render } from "./new-video-sec-full-bleed.vue?vue&type=template&id=7341a800&scoped=true"
import script from "./new-video-sec-full-bleed.vue?vue&type=script&lang=js"
export * from "./new-video-sec-full-bleed.vue?vue&type=script&lang=js"

import "./new-video-sec-full-bleed.vue?vue&type=style&index=0&id=7341a800&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7341a800"]])

export default __exports__